import { pageUrls } from 'globalconfig/constants/keys';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import { UI_DATE_FORMAT } from 'globalconfig/constants/static';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { lazy } from 'react';
import { columns } from './config';

const layout = window?.$environment?.CURRENT_LAYOUT;
const beBaseUrl = window?.$environment?.BE_BASE_URL;
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));

const Component = ({ infoBlockItems, history, Styled, i18n, logBook }) => {
  const generateRows = () => {
    const updatedList = infoBlockItems.map((item) => {
      item.report = (
        <a
          href={`${beBaseUrl}/document/open/${item?.reportid}?token=${logBook?.documentToken}`}
          className="viewReport"
          target="_blank"
          rel="noopener noreferrer"
        >
          {i18n.t('accidents.viewReport')}
        </a>
      );
      item.date = moment(item.date).format(UI_DATE_FORMAT);
      return item;
    });
    return updatedList;
  };

  return (
    <>
      <Styled.Inspectionview>
        <div className="viewAll">
          <Icon
            src={mediaUrls?.viewMoreIcon}
            onClick={() => history.push(pageUrls.inspections)}
            tooltip={i18n.t('common.viewMore')}
            className="roadDetails"
          />
          <span className="viewmore" onClick={() => history.push(pageUrls.inspections)}>
            {i18n.t('common.viewMore')}
          </span>
        </div>
      </Styled.Inspectionview>
      <Styled.TableWrapper>
        <Table
          type="client"
          defaultSortBy={{ sortBy: 'date', order: 'desc' }}
          title=""
          columns={columns}
          data={generateRows()}
          emptyMessage={i18n.t('common.tableEmptyMessage')}
          itemsPerPage={window.$environment.CURRENT_LAYOUT === 'OldUi' ? 5 : 10}
          actions={[]}
          defaultSort={'date'}
          i18n={i18n}
        />
      </Styled.TableWrapper>
    </>
  );
};

export default Component;

Component.propTypes = {
  history: PropTypes.object.isRequired,
};
